import {API, SW_API} from './constants.types'

const currentHost = window.location.hostname || "";
let BE_HOST1 = "https://smartpay-backend.tabsquare.com/"
let SW_HOST1 = "https://smartweb-ecms.tabsquare.com/"
let SW_BE_HOST1 = "https://smartweb-be.tabsquare.com"
let THEME_JSON_HOST1 = "https://cdn-kube.tabsquare.com"
let LD_KEY = "63fdba1857945e13d9668ac1";
if (currentHost.indexOf("stg") > -1 || currentHost.indexOf("stage") > -1 || currentHost.indexOf("127.0.0.1") > -1 || currentHost.indexOf("localhost") > -1) {
  BE_HOST1 = "http://localhost:3010/"
  SW_HOST1 = "https://smartweb-ecms.stage.tabsquare.dev/"
  SW_BE_HOST1 = "https://smartweb-be.stage.tabsquare.dev/"
  THEME_JSON_HOST1 = "https://images.stage.tabsquare.dev"
  LD_KEY = "6406eed191f9b01348aa9b2c";
} else if(currentHost.indexOf("uat") > -1) {
  BE_HOST1 = "https://smartpay-backend.uat.tabsquare.dev/"
  SW_HOST1 = "https://smartweb-ecms.uat.tabsquare.dev/"
  SW_BE_HOST1 = "https://smartweb-be.uat.tabsquare.dev"
  THEME_JSON_HOST1 = "https://images.uat.tabsquare.dev"
  LD_KEY = "63fdba2657945e13d9668ae7";
} 

export const BE_HOST = BE_HOST1
export const SW_HOST = SW_HOST1
export const SW_BE_HOST = SW_BE_HOST1
/** Studio theme.json CDN origin. Prefer `REACT_APP_THEME_JSON_HOST`; hostname fallback matches deploy env. No trailing slash. */
export const THEME_JSON_HOST = (process.env.REACT_APP_THEME_JSON_HOST || THEME_JSON_HOST1).replace(/\/$/, "")
export const LD_CLIENT_SIDE_KEY = LD_KEY;

/** CDN URL for Studio theme.json. Fetch is session-cached per merchant in applyTheme — not here. */
export const themeJsonUrl = (pathMerchantId: string) =>
  `${THEME_JSON_HOST}/smartweb/themes/${encodeURIComponent(pathMerchantId)}/theme.json`

export const BE_API:API = {
  SCAN_TOKEN: "/v1/scan",
  SETTING:'/v1/settings',
  SETTING_V2:'/v2/settings',
  BILL:'/v1/bill',
  INITIATE_PAYMENT: '/v1/bill/payment',
  PAYMENT_NOTIF: '/v1/payment/notification',
  PAYMENT_STATUS: '/v1/bill/payment',
  SEND_BILL: '/v1/bill/send',
  PROXY: 'proxy/',
  VALIDATE_APPLE: '/v1/validate/checkout-apple',
  SPLIT_INFO: '/v1/payment/refreshsplitbill',
  CALCULATE_FEE: '/v1/calculate-fee',
  LOG: '/log',
  FEEDBACK_CONFIG: (merchantKey: string) =>
    `/v1/merchants/${encodeURIComponent(merchantKey)}/feedback/config`,
}

export const SW_BE_API:SW_API = {
  PAYMENT_SETTINGS: (merchantKey: string) => {
    if(!merchantKey) {
      return null;
    }
    return `/api/v1/merchants/${merchantKey}/payment-settings`;
  }
}

export const PAYMENT_STATUS_MAX_API_CALLS= 60 // IN COUNT

export const SHARED_SESSION_ID_COOKIE = 'sharedSessionId'

export const VISIT_FEEDBACK_DISMISSED_STORAGE_KEY = 'visitFeedbackDismissedSession'

export const GET_BILL_MAX_TIME_LIMIT_DIFF = 30 // IN SECONDS

export const MAX_REFRESH_DISABLE_TIME = 30000 // IN MILLI SECONDS

export const SUPPORTED_LANGS = ['en']

export const PRIVACY_POLICY = "https://tabsquare.ai/smw-privacy-policy_"

export const TERMS_OF_USE = "https://tabsquare.ai/smw-terms-of-use_"

export const GOOGLE_WRITE_REVIEW_URL = 'https://search.google.com/local/writereview'

export const REGEX_EMAIL = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const REGEX_TIP_AMT = /^\d*(\.\d+)?$/;

export const TIME_FORMAT = 'HH:mm:ss'

export const YEAR_FORMAT = 'YYYY-MM-DD'

export const PERCENTAGE_TIP = 'p'

export const CUSTOM_TIP = 'o'

export const NO_TIP = 'n'

export const PAYMENT_ACTION = 'p'

export const REFRESH_ACTION = 'r'

export const MAX_TIP_AMOUNT_0_CASE = 100

export const PAYMENT_CHANNEL = {
  STRIPE: 'STRIPE',
  RAZER: 'RAZER',
  CHECKOUT: 'CHECKOUT',
  CHECKOUT_GOOGLE_PAY: 'CHECKOUT_GOOGLE_PAY',
  CHECKOUT_APPLE_PAY: 'CHECKOUT_APPLE_PAY'
}

export const CHECK_BILL = true;

export const PAYMENT_INIT_ACTION = {
  PAYMENT_INIT: "PAYMENT_INIT",
  PAYMENT_POPUP: "PAYMENT_POPUP",
  EMAIL_POPUP_CONT: "EMAIL_POPUP_CONT",
  EMAIL_POPUP_SKIP: "EMAIL_POPUP_SKIP",
  BILL_CHANGE_CONT: "BILL_CHANGE_CONT",
  CHECKOUT_LOADING: "CHECKOUT_LOADING",
  CHECKOUT_INIT: "CHECKOUT_INIT",
  CHECKOUT_GOOGLE_INIT:"CHECKOUT_GOOGLE_INIT",
  CHECKOUT_APPLE_INIT:"CHECKOUT_APPLE_INIT"
}

export const CHECKOUT_CDN = "https://cdn.checkout.com/js/framesv2.min.js";

export const CHECKOUT_LANG_MAP = {
  'en': "EN-GB",
  'ar': "AR"
}

export const GOOGLE_PAY_CDN = "https://pay.google.com/gp/p/js/pay.js"

export const SPLIT_TYPE = {
  CUSTOM: 'CUSTOM',
  EQUAL: 'EQUAL'
}

export const SPLIT_THRESHOLD = 1;

export const MIN_NO_OF_PEOPLE_ON_TABLE = 2;

export const MIN_NO_OF_PEOPLE_PAYING_FOR = 2;

export const NAME_REGEX = /^(?!\p{Zs})(?!.*\p{Zs}$)[\p{L}\p{M}\p{Zs}]{1,30}$/u

export const ROUNDING_RULE = {
  HUNDRED: "HUNDRED",
  NTD: "NTD"
}

export const BILL_CHANGE_POPUP = {
  NO_SPLIT: 'NO_SPLIT',
  BILL_CHANGE: 'BILL_CHANGE',
  BALANCE_CHANGE: 'BALANCE_CHANGE'
}

export const WITH_TIP = true;

export const PAGES = {
  LANDING:'LANDING',
  BILL: 'BILL'
}

export const EVENTS = {
  V1_SCAN_QR_INFO: 'V1_SCAN_QR_INFO',
  V1_SCAN_SETTING: 'V1_SCAN_SETTING',
  V2_SCAN: 'V2_SCAN',
  PAGE_NOT_FOUND:'PAGE_NOT_FOUND',
  INITIATE_PAYMENT: 'INITIATE_PAYMENT'
}

export enum AuditEventType {
  V1_SCAN_QR='V1_SCAN_QR',
  V2_SCAN_QR='V2_SCAN_QR',
  V1_SETTINGS='V1_SETTINGS',
  PAYMENT_NOTIFICATION='PAYMENT_NOTIFICATION',
  GET_PAYMENT_STATUS='GET_PAYMENT_STATUS',
  SEND_BILL_TO_MAIL='SEND_BILL_TO_MAIL',
  SW_PAYMENT_SETTINGS='SW_PAYMENT_SETTINGS',
  GET_BILL='GET_BILL',
  INITIATE_PAYMENT='INITIATE_PAYMENT',
  GET_BILL_POLL='GET_BILL_POLL',
  VALIDATE_APPLE_SESSION='VALIDATE_APPLE_SESSION',
  PAYMENT_SETTING_SW='PAYMENT_SETTING_SW',
  CALCULATE_FEE='CALCULATE_FEE',
  GET_FEEDBACK_CONFIG='GET_FEEDBACK_CONFIG'
}

export const LOADING = true;

export enum COUNTRY_CODE {
  UAE = "AE",
  SG = "SG"
}

export enum FEATURE_FLAGS {
  SMTWB_6822_DIRECT_PAYMENT = 'smtwb-6822-direct-payment',
  ENABLE_SMARTPAY_PF = 'smartpay-platform-fee-changes-smtwb-8621',
  ENABLE_SMARTPAY_CHECKOUT_POPUP = 'smartpay-checkout-popup-smtwb-9084',
  SMTWB_9172_ENABLE_SWIPE_BUTTON_FOR_CHECKOUT_POPUP = 'smtwb-9172-enable-swipe-button-for-checkout-popup',
  SMTWB_9162_USE_ICONS_FROM_API = 'smtwb-9162-use-icons-from-api',
  SMTWB_9159_ENABLE_VISIT_FEEDBACK = 'smtwb-9159-enable-visit-feedback',
  SMTWB_9198_HANDLE_EMPTY_BILL_STATE = 'smtwb-9198-handle-empty-bill-state-smartpay',
  SMTWB_9346_PREVENT_ORDER_WHEN_TABLE_FULLY_PAID = 'smtwb-9346-prevent-user-from-placing-order-when-the-table-is-fully-paid',
}

// Case-insensitive match against referenceId path param signaling the table's bill is already fully paid.
export const TABLE_FULLY_PAID_REFERENCE_ID = 'fully paid';

// Error code from GET /v1/bill and /v1/payment/refreshsplitbill when the bill is 0 with no items.
// The backend only sends it while SMTWB_9198_HANDLE_EMPTY_BILL_STATE is on for the merchant.
export const EMPTY_BILL_ERROR_CODE = 'order-is-empty';

export enum PAYMENT_LAYOUT_TYPE {
  DEFAULT = 'DEFAULT',
  DIRECT = 'DIRECT'
}

export const API_CANCELLED_TIMEOUT_ERR = 'ERR_CANCELED'